const einProgram = {
  einProgram: {
    pageHeader: 'Leads e Enphase Installer Network',
    title: 'Associação EIN aceita',
    overview: 'Visão geral',
    noCompany: 'Nenhuma empresa encontrada',
    goToDashboard: 'Ir para o painel',
    messageFromCeo: 'Leia a mensagem do nosso CEO',
    companyProfileLink: 'Atualize o perfil da sua empresa',
    serviceAreasLink: 'Selecione suas áreas de serviço',
    leadsPreferencesLink: 'Defina suas preferências de leads',
    reviewInstallerLink: 'Revise os T&Cs da instaladora',
    open: 'abrir',
    video: 'vídeo',
    selected: 'selecionado',
    learnMore: 'Saiba mais',
    completed: 'Concluído',
    pending: 'Pendente',
    optInDisabledHeader: 'Programa EIN (em breve)',
    optInDisabledDescription: 'A Enphase Installer Network (EIN) é uma ótima maneira de os proprietários residenciais encontrarem você! Os proprietários confiam na EIN para identificar as instaladoras que oferecem os mais altos padrões de atendimento ao cliente e qualidade do sistema usando os produtos Enphase. Como membro da EIN, você pode desfrutar de diversos benefícios que o ajudarão a vender mais, instalar mais e fazer mais.',
    einTier: 'Seu nível Enphase Installer Network (EIN): ',
    none: 'Nenhum',
    viewBenefits: 'Para ver seus benefícios EIN, clique em ',
    here: 'aqui',
    anyQuestions: ' Se você tiver alguma dúvida sobre sua associação EIN, entre em contato com seu ',
    enphaseAccountRepresentative: ' representante da conta Enphase.',
    learnReceivingLeads: 'Saiba como você receberá leads da plataforma digital da Enphase,',
    benefitsOfEIN: 'Veja os benefícios da EIN',
    contactEnphaseRepresentative: '. Entre em contato com o representante da sua conta da Enphase para saber mais sobre a EIN e o programa de leads da Enphase.',
    congratulations: 'Parabéns!',
    whichInstaller: '%{tierName} Instaladora. ',
    invitationText1: 'Você foi convidada a participar da Enphase Installer Network (EIN) como uma ',
    invitationText2: 'A Enphase Installer Network (EIN) é a nossa rede confiável de instaladoras que proporcionam uma experiência excepcional ao proprietário usando produtos Enphase. A EIN tem como objetivo fortalecer nosso relacionamento com você e acelerar o seu crescimento. Como membro da EIN, você pode desfrutar de diversos benefícios que o ajudarão a vender mais, instalar mais e fazer mais. Reveja os benefícios completos ',
    acceptInvitation: 'Para aceitar o seu convite:',
    acceptTerms: 'Eu aceito os termos e condições',
    cellmodemCheck: 'Eu aceito os',
    cellmodemTeamcondition: ' termos e condições ',
    cellmodemLinkTitle: 'do Extensão de dados do Mobile Connect',
    notEstablished: 'Não estabelecido.',
    contactEin: 'Entre em contato com o representante da sua conta da Enphase para saber mais sobre o EIN.',
    getFreeLeads: 'Para obter leads gratuitos, conclua as etapas abaixo'
  }
};

export default einProgram;
